import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

const SUBMIT_DELAY = 1000;

export default class extends Controller {
  static targets = ['fieldset'];

  save() {
    window.clearTimeout(this.submitTimer);
    this.submitTimer = window.setTimeout(this.fire.bind(this), SUBMIT_DELAY);
  }

  fire() {
    Rails.fire(this.element, 'submit');
    if (this.hasFieldsetTarget) this.fieldsetTarget.setAttribute('disabled', true);
  }
}
